import { Navigate } from 'react-router-dom';
import { authStorage } from '@/features/auth/config/auth-storage';

interface AuthGuardProps {
  children: React.ReactNode;
}

export const AuthGuard = ({ children }: AuthGuardProps) => {
  const token = authStorage.getItem('access_token');
  const isAuthenticated = !!token && token !== 'undefined';

  if (isAuthenticated) {
    return <Navigate to='/dashboard' replace />;
  }

  return <>{children}</>;
};
